import { render, staticRenderFns } from "./DifferentialItem.vue?vue&type=template&id=0d7478d2"
import script from "./DifferentialItem.vue?vue&type=script&lang=js"
export * from "./DifferentialItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports